// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {id: 1, nome: "Pedro", nota: 5.5 },
    {id: 2, nome: "Julia", nota: 6.5 },
    {id: 3, nome: "Flavio", nota: 7.3 },
    {id: 4, nome: "Saulo", nota: 4.5 },
    {id: 5, nome: "Ander", nota: 9.3 },
    {id: 6, nome: "Dani", nota: 9.2 },
    {id: 7, nome: "Arthur", nota: 5.6 },
]